/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Charts_Legend_PlannedInputs */

const en_us2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

const pt_br2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejado`)
};

const es_419_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeado`)
};

const pt_pt2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeado`)
};

const fr_fr2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévu`)
};

const de_de2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant`)
};

const it_it2_ui_charts_legend_planned = /** @type {(inputs: Ui_Charts_Legend_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsto`)
};

/**
* | output |
* | --- |
* | "Planned" |
*
* @param {Ui_Charts_Legend_PlannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_legend_planned = /** @type {((inputs?: Ui_Charts_Legend_PlannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Legend_PlannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_legend_planned(inputs)
	if (locale === "es-419") return es_419_ui_charts_legend_planned(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_legend_planned(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_legend_planned(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_legend_planned(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_legend_planned(inputs)
	return en_us2_ui_charts_legend_planned(inputs)
});
export { ui_charts_legend_planned as "ui-charts.legend_planned" }